import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function TipoConta({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.8072 0H13.1922C13.6565 0 14.0332 0.375976 14.0332 0.841V2.2998H19.8368C20.8659 2.2998 21.6998 3.13366 21.6998 4.1628V22.1368C21.6998 23.1659 20.8659 23.9998 19.8368 23.9998H4.1628C3.13366 23.9998 2.2998 23.1659 2.2998 22.1368V4.1628C2.2998 3.13366 3.13366 2.2998 4.1628 2.2998H9.9662V0.841C9.9662 0.375976 10.3429 0 10.8072 0ZM10.9662 2.82451C10.9666 2.81632 10.9668 2.80808 10.9668 2.7998C10.9668 2.79152 10.9666 2.78328 10.9662 2.77509V1H13.0332V2.7796C13.0329 2.7863 13.0328 2.79303 13.0328 2.7998C13.0328 2.80657 13.0329 2.8133 13.0332 2.82V3.833H10.9662V2.82451ZM9.9662 3.2998H4.1628C3.68595 3.2998 3.2998 3.68594 3.2998 4.1628V22.1368C3.2998 22.6137 3.68595 22.9998 4.1628 22.9998H19.8368C20.3137 22.9998 20.6998 22.6137 20.6998 22.1368V4.1628C20.6998 3.68594 20.3137 3.2998 19.8368 3.2998H14.0332V3.993C14.0332 4.45741 13.6561 4.833 13.1922 4.833H10.8072C10.3433 4.833 9.9662 4.45741 9.9662 3.993V3.2998ZM11.9934 11.82C13.3544 11.8037 14.4439 10.6862 14.4264 9.32554C14.4088 7.96493 13.2926 6.87548 11.932 6.89304C10.5722 6.90935 9.48313 8.02596 9.49944 9.38699C9.51575 10.7469 10.6331 11.8363 11.9934 11.82ZM11.9444 7.89296C12.7529 7.88253 13.416 8.52973 13.4264 9.33846C13.4369 10.1466 12.7897 10.8104 11.9814 10.82C11.173 10.8297 10.5091 10.1824 10.4994 9.375C10.4897 8.566 11.1367 7.90265 11.9444 7.89296ZM12.0114 13.3107C9.84841 13.3373 8.11556 15.1137 8.14217 17.2776C8.14556 17.5537 7.92447 17.7803 7.64835 17.7837C7.37223 17.7871 7.14564 17.566 7.14224 17.2898C7.10885 14.5738 9.28381 12.3441 11.9989 12.3107C14.7158 12.2762 16.9458 14.4511 16.9792 17.1676C16.9826 17.4437 16.7615 17.6703 16.4854 17.6737C16.2092 17.6771 15.9826 17.456 15.9792 17.1798C15.9526 15.0158 14.1761 13.2832 12.0114 13.3107Z'
      />
    </svg>
  );
}
